export function vpv(uri) {
  return window.hj && window.hj("vpv", uri);
}
